const useranswers = new Array()
let answered = 0

let rendered = false

const renderQuiz = element =>{
    if(rendered === true){return}
    element.insertAdjacentHTML('afterbegin',
        `
            ${questions.map((question, index) =>
                `
                    <p class="question">
                        ${question}
                        <span id="result_${index}">
                            <img src="Images/Stelter/blank.gif" style="border:0" alt="" />
                        </span>
                    </p>
                    ${choices[index].map((choice, cIndex) =>
                        `
                            <input type="radio" name="answer_${cIndex}" value="${choice}" id="answer_${index}_${cIndex}" class="question_${index}" onclick="submitAnswer('${index}', this, 'question_${index}', 'label_${index}_${cIndex}')" />
                            <label id="label_${index}_${cIndex}" for="answer_${index}_${cIndex}">
                                ${choice}
                            </label>
                            <br />
                        `
                    ).join('')}
                `
            ).join('')}
            <p class="quiz-buttons">
                <input type="submit" value="Show Score" onclick="showScore()" />
                <input type="submit" value="Reset Quiz" onclick="resetQuiz(true)" />
            </p>
            <p style="display:none">
                <img src="Images/Stelter/correct.gif" style="border:0" alt="Correct!" />
                <img src="Images/Stelter/incorrect.gif" style="border:0" alt="Incorrect!" />
            </p>
        `
    )
    rendered = true
}

const resetQuiz = showConfirm => {
    if (showConfirm){
        if (!confirm("Are you sure you want to reset your answers and start from the beginning?")){
            return false
        }
    }
    document.location = document.location;
}

const submitAnswer = (questionId, obj, classId, labelId) => {
    useranswers[questionId] = obj.value
    document.getElementById(labelId).style.fontWeight = "bold"
    disableQuestion(classId)
    showResult(questionId)
    answered++
}

const showResult = questionId =>
    answers[questionId] === useranswers[questionId] ?
    document.getElementById(`result_${questionId}`).innerHTML = `<img src="Images/Stelter/correct.gif" style="border:0" alt="Correct!" />` :
    document.getElementById(`result_${questionId}`).innerHTML = `<img src="Images/Stelter/incorrect.gif" style="border:0" alt="Incorrect!" />`

const scoreMessage = score => {
    switch (score) {
        case 100: return response[0]
        case score >= 90: return response[1]
        case score >= 70: return response[2]
        case score > 50: return response[3]
        case score >= 40: return response[4]
        case score >= 20: return response[5]
        case score >= 10: return response[6]
        default: return response[7]
    }
}

function showScore() {
    if (answered != answers.length) {
        alert("You have not answered all of the questions yet!")
        return false
    }

    let correct = 0
    let incorrect = 0
    useranswers
        .forEach( (value,index) =>
            value === answers[index]
            ?
                correct++
            :
                incorrect++
        )

    let percentCorrect = Math.round((correct / answers.length) * 100)
    let alertMsg =
        `
            You scored ${correct} out of ${answers.length}

            You correctly answered ${percentCorrect}% of the questions!

        `

    scoreMessage(percentCorrect)
    return percentCorrect < 100 ? ( confirm(alertMsg) ? resetQuiz(false) : false ) : alert(alertMsg)
}

const disableQuestion = classId => {
    return [].slice.call(
        document.getElementsByClassName(classId)
    )
    .forEach(input => input.disabled = true)
}
